export interface UserProfile {
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  companyFunction: string;
}

export enum UserRole {
  TabOwner = "TabOwner",
  Coordinator = "Coordinator",
  Endorser = "Endorser",
  Guest = "Guest",
  Administrator = "Administrator",
  Requestor = "Requestor",
  Owner = "Owner"
}

export enum LAMSRole {
  Owner = 0,
  Requestor = 1,
  Admin = 2,
  Endorser = 3,
  Coordinator = 5,
  TabOwner = 6,

  /*
   * Note - SecondaryEndorser(33) and SecondaryCoordinator(55) are frontend only.
   * Extending Endorser(3) and Coordinator(5) for the display/selection of their Secondaries.
   */
  SecondaryEndorser = 33,
  SecondaryCoordinator = 55
}
